import React from 'react';
import { Check } from 'lucide-react';

interface Step {
  id: number;
  label: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="card-surface p-5">
      <h3 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">Progress</h3>
      <div className="space-y-3">
        {steps.map((step, idx) => {
          const done = currentStep > step.id;
          const active = currentStep === step.id;
          return (
            <div key={`step-${step.id}`} className="flex items-start gap-3">
              {/* Connector line */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold transition-all duration-200 ${
                    done
                      ? 'bg-positive text-white'
                      : active
                      ? 'bg-primary text-white shadow-glow'
                      : 'bg-secondary text-muted-foreground border border-border'
                  }`}
                >
                  {done ? <Check size={14} /> : step.id}
                </div>
                {idx < steps.length - 1 && (
                  <div className={`w-0.5 h-8 mt-1 ${done ? 'bg-positive' : 'bg-border'} transition-colors duration-300`} />
                )}
              </div>
              <div className="pt-1">
                <p className={`text-sm font-semibold ${active ? 'text-foreground' : done ? 'text-positive' : 'text-muted-foreground'}`}>
                  {step.label}
                </p>
                {active && (
                  <p className="text-xs text-primary mt-0.5">In progress</p>
                )}
                {done && (
                  <p className="text-xs text-positive mt-0.5">Complete</p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Job number display */}
      <div className="mt-6 p-3 rounded-lg border border-border bg-input">
        <p className="text-xs text-muted-foreground uppercase tracking-widest mb-1">Job Number</p>
        <p className="font-mono-data text-lg font-bold text-primary">#1009</p>
        <p className="text-xs text-muted-foreground mt-1">Auto-assigned · Sequential</p>
      </div>
    </div>
  );
}